import React, { useCallback } from 'react';
import { TableBody } from '@material-ui/core';
import Table from '../../DesignSystem/Table';
import { SortOrder } from '../../../enums';
import PortRow from './PortRow';
import { TableConstants } from '../../../utils/appConstants';
import EmptyRow from '../../DesignSystem/Table/Rows/EmptyRow';
import LoadingRow from '../../DesignSystem/Table/Rows/LoadingRow';
import { headCellsList as headCellsData } from './headCells';

interface PortTableProps {
  loading: boolean;
  ports: any;
  totalPages: number;
  page: number;
  order: SortOrder;
  orderBy: string;
  rowProps: any;
  onPageChange: (page: number) => void;
  onRequestSort: (property: string, nextSortOrder: SortOrder) => void;
  onRequestSearch?: (property: string) => void;
  onSearchClose?: (property: string) => void;
  refetch: () => void;
}

const ListPortsTable: React.FC<PortTableProps> = ({
  ports, page, totalPages, loading, order, orderBy, onSearchClose, onRequestSort, onRequestSearch, onPageChange, rowProps, refetch,
}) => {
  const handlePageChange = useCallback((event: any, value: number) => {
    onPageChange(value);
  }, [onPageChange]);

  let rows;
  if (loading) {
    rows = <LoadingRow colSpan={headCellsData.length + 1} />;
  } else if (!ports || ports.length === 0) {
    rows = <EmptyRow text={TableConstants.noRecordsFound} colSpan={headCellsData.length + 1} />;
  } else {
    rows = ports.map((port: any, index: number) => {
      return (
        <PortRow
          on_net={port.on_net}
          onRequestVerification={rowProps.onRequestVerification}
          onEditPort={rowProps.onEditPort}
          cancelSubLoading={rowProps.cancelSubLoading}
          onCancelSubscription={rowProps.onCancelSubscription}
          onSaleClick={rowProps.onSaleClick}
          onSaleEdit={rowProps.onSaleEdit}
          onRemoveClick={rowProps.onRemoveClick}
          removeLoadingId={rowProps.removeLoadingId}
          port={port}
          key={index}
          rowSelected={false}
          selected={[]}
          onSelectRow={() => {}}
          isList
          refetch={refetch}
        />
      );
    });
    rows = <TableBody>{rows}</TableBody>;
  }

  return (
    <Table
      order={order}
      orderBy={orderBy}
      rowCount={ports.length}
      headCells={headCellsData}
      onRequestSort={onRequestSort}
      onRequestSearch={onRequestSearch}
      onSearchClose={onSearchClose}
      rowSelectionAvailable={false}
      numSelected={0}
      rows={rows}
      totalPages={totalPages}
      page={page}
      onPageChange={handlePageChange}
    />
  );
};

export default ListPortsTable;
